
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/purchase-tokens",
      function () {
        return require("private-next-pages/developer/purchase-tokens/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/purchase-tokens"])
      });
    }
  